import { Apps } from '~/shared';
import adsIcon from '../../assets/icons/apps/ads.svg';
import auctionIcon from '../../assets/icons/apps/auction.svg';
import messageIcon from '../../assets/icons/apps/message.svg';
import myBusinessIcon from '../../assets/icons/apps/my_business.svg';
import truckJobIcon from '../../assets/icons/apps/truck_job.svg';
import adsLauncherIcon from '../../assets/icons/launcherIcons/ads.svg';
import auctionLauncherIcon from '../../assets/icons/launcherIcons/auction.svg';
import cameraLauncherIcon from '../../assets/icons/launcherIcons/camera.svg';
import messageLauncherIcon from '../../assets/icons/launcherIcons/message.svg';
import myBusinessLauncherIcon from '../../assets/icons/launcherIcons/my_business.svg';
import truckJobLauncherIcon from '../../assets/icons/launcherIcons/truck_job.svg';

export interface ITabletApp {
	app: Apps;
	name: string;
	icon: string;
	loadingIcon?: string;
	loadingMessage?: string;
	color: string;
}

export const appList: ITabletApp[] = [
	{
		app: Apps.Launcher,
		name: 'Лаунчер',
		icon: '',
		color: '',
	},
	{
		app: Apps.Camera,
		name: 'Камера',
		icon: cameraLauncherIcon,
		color: '',
	},
	{
		app: Apps.Message,
		name: 'Сообщения',
		icon: messageLauncherIcon,
		loadingIcon: messageIcon,
		loadingMessage: 'Подождите, идёт загрузка сообщений...',
		color: '#77DE38',
	},
	{
		app: Apps.Ads,
		name: 'Объявления',
		icon: adsLauncherIcon,
		loadingIcon: adsIcon,
		loadingMessage: 'Подождите, идёт загрузка товаров...',
		color: '#965EEB',
	},
	{
		app: Apps.Auction,
		name: 'Аукцион',
		icon: auctionLauncherIcon,
		loadingIcon: auctionIcon,
		loadingMessage: 'Подождите, идёт загрузка товаров...',
		color: '#FF1E00',
	},
	{
		app: Apps.MyBusiness,
		name: 'Мой бизнес',
		icon: myBusinessLauncherIcon,
		loadingIcon: myBusinessIcon,
		loadingMessage: 'Подождите, идёт загрузка данных...',
		color: '#3491E9',
	},
	{
		app: Apps.TruckJob,
		name: 'SDEK',
		icon: truckJobLauncherIcon,
		loadingIcon: truckJobIcon,
		loadingMessage: 'Подождите, идёт загрузка заказов...',
		color: '#1AB248',
	},
];

export const getAppName = (app: Apps) =>
	appList.find((item) => item.app === app)?.name || '';
export const getAppIcon = (app: Apps) =>
	appList.find((item) => item.app === app)?.icon || '';
export const getAppLoadingInfo = (app: Apps) => {
	const info = appList.find((item) => item.app === app);
	return {
		loadingIcon: info?.loadingIcon || '',
		loadingMessage: info?.loadingMessage || '',
		name: info?.name || '',
		color: info?.color || '',
	};
};
